export default "data:video/mp2t;base64,ZXhwb3J0IGNvbnN0IEpPVVJORVlfTEFCRUxfRkxZQklUU19JTlRFUk5BTCA9ICdmbHliaXRzLWludGVybmFsJzsK"